import graphqlService from "./axiosInstances/graphql";
import { store } from "store";

// GraphQL query for searching users by email
const SEARCH_USERS_QUERY = `
  query users($where: UserWhereInput) {
    users(where: $where) {
      result {
        id
        firstName
        lastName
        email
        mobile
        iamAuthId
        isEmailVerified
        isMobileVerify
        isd
      }
      totalCount
    }
  }
`;

// GraphQL mutation for creating users
const CREATE_USER_MUTATION = `
  mutation CreateUser($data: createUserInput!) {
    createUser(data: $data) {
      id
      firstName
      lastName
      email
      mobile
      isd
    }
  }
`;

// Function to search users by email using GraphQL
export const searchUsersByEmail = async (email) => {
  try {
    const response = await graphqlService.post("/graphql", {
      query: SEARCH_USERS_QUERY,
      variables: {
        where: {
          _or: [
            {
              email: {
                _regex: email,
                _options: "$i",
              },
            },
          ],
        },
      },
    });

    if (response.data && response.data.data && response.data.data.users) {
      return response.data.data.users;
    }

    return { result: [], totalCount: 0 };
  } catch (error) {
    console.error("Error searching users by email:", error);
    return { result: [], totalCount: 0 };
  }
};

// Function to create user using GraphQL
export const createUserGraphQL = async (userData) => {
  try {
    const response = await graphqlService.post("/graphql", {
      query: CREATE_USER_MUTATION,
      variables: {
        data: {
          firstName: userData.firstName,
          lastName: userData.lastName,
          email: userData.email,
          mobile: userData.phoneNumber,
          password: "",
          gRecaptchaResponse: "",
          createdFrom: "phoenix",
          isd: userData.isd || "+91", // Include ISD code with default
        },
      },
    });

    if (response.data && response.data.data && response.data.data.createUser) {
      return response.data.data.createUser;
    }

    throw new Error("Failed to create user");
  } catch (error) {
    console.error("Error creating user via GraphQL:", error);
    throw error;
  }
};

// Function to search users by mobile number using GraphQL
export const searchUsersByMobile = async (mobile) => {
  try {
    const response = await graphqlService.post("/graphql", {
      query: SEARCH_USERS_QUERY,
      variables: {
        where: {
          _or: [
            {
              mobile: mobile,
            },
          ],
        },
      },
    });

    if (response.data && response.data.data && response.data.data.users) {
      return response.data.data.users;
    }

    return { result: [], totalCount: 0 };
  } catch (error) {
    console.error("Error searching users by mobile:", error);
    return { result: [], totalCount: 0 };
  }
};

// Function to search users by email or mobile using GraphQL
export const searchUsersByEmailOrMobile = async (email, mobile) => {
  try {
    const response = await graphqlService.post("/graphql", {
      query: SEARCH_USERS_QUERY,
      variables: {
        where: {
          _or: [
            {
              email: {
                _regex: email,
                _options: "$i",
              },
            },
            {
              mobile: mobile,
            },
          ],
        },
      },
    });

    if (response.data && response.data.data && response.data.data.users) {
      return response.data.data.users;
    }

    return { result: [], totalCount: 0 };
  } catch (error) {
    console.error("Error searching users by email or mobile:", error);
    return { result: [], totalCount: 0 };
  }
};

// Function to search users by mobile number with ISD using GraphQL
export const searchUsersByMobileWithIsd = async (mobile, isd) => {
  try {
    const response = await graphqlService.post("/graphql", {
      query: SEARCH_USERS_QUERY,
      variables: {
        where: {
          _or: [
            {
              isd: isd,
              mobile: mobile,
            },
          ],
        },
      },
    });

    if (response.data && response.data.data && response.data.data.users) {
      return response.data.data.users;
    }

    return { result: [], totalCount: 0 };
  } catch (error) {
    console.error("Error searching users by mobile with ISD:", error);
    return { result: [], totalCount: 0 };
  }
};

// Function to search users by email or mobile with ISD using GraphQL
export const searchUsersByEmailOrMobileWithIsd = async (email, mobile, isd) => {
  try {
    const response = await graphqlService.post("/graphql", {
      query: SEARCH_USERS_QUERY,
      variables: {
        where: {
          _or: [
            {
              email: {
                _regex: email,
                _options: "$i",
              },
            },
            {
              isd: isd,
              mobile: mobile,
            },
          ],
        },
      },
    });

    if (response.data && response.data.data && response.data.data.users) {
      return response.data.data.users;
    }

    return { result: [], totalCount: 0 };
  } catch (error) {
    console.error("Error searching users by email or mobile with ISD:", error);
    return { result: [], totalCount: 0 };
  }
};
